import {
  successSendUpdateData,
  failSendUpdateData,
  sendUpdateData,
  setDayProgress,
} from '../actions/user-data';
import { actions } from 'react-redux-form';
import { clickLogout } from '../actions/auth';
import moment from 'moment';
import _ from 'lodash';
import store from '../store/configureStore';
import { toast } from 'react-toastify';
import appEventHandler from './storeMountCheck';
import superFetch from './superFetch';

function uploadUserDataInBackground(user, userData, logoutFlag = false) {
  uploadUserData(user, userData, logoutFlag).catch((error) => {
    // WebSocketイベント等から開始した同期には await する呼び出し元がないため、
    // ここで reject を処理して Uncaught (in promise) を防ぐ。
    console.error('Background sync failed:', error);
  });
}

function fallbackUploadAfterSocketFailure(user) {
  const { userData } = store.getState();
  console.log('socket authcheck unavailable. fallback upload.');
  uploadUserDataInBackground(user, userData);
}

export function openSocket(user, global, loginFlag) {
  //return false;
  let ws;
  try {
    ws = new WebSocket(global.wsUrl);
  } catch (error) {
    console.error('create socket failed', error);
    window.ws = undefined;
    if (!loginFlag && user) {
      fallbackUploadAfterSocketFailure(user);
    }
    return null;
  }
  window.ws = ws;
  console.log('create socket');
  let authcheckHandled = false;
  let authcheckTimeout = null;

  const clearAuthcheckTimeout = () => {
    if (authcheckTimeout) {
      clearTimeout(authcheckTimeout);
      authcheckTimeout = null;
    }
  };

  const fallbackAuthcheck = () => {
    if (loginFlag || authcheckHandled || !user) {
      return;
    }
    authcheckHandled = true;
    clearAuthcheckTimeout();
    fallbackUploadAfterSocketFailure(user);
  };

  ws.onopen = () => {
    if (loginFlag) {
      try {
        ws.send(
          JSON.stringify({ action: 'login', status: 'ok', email: user.email })
        );
      } catch (error) {
        console.error('ws send login failed', error);
      }
    } else {
      if (user) {
        try {
          ws.send(JSON.stringify({ action: 'authcheck', email: user.email }));
          authcheckTimeout = setTimeout(() => {
            console.warn('authcheck timeout');
            fallbackAuthcheck();
          }, 5000);
        } catch (error) {
          console.error('ws send authcheck failed on open', error);
          fallbackAuthcheck();
        }
      }
    }

    console.log('ws open');
    ws.onmessage = (e) => {
      let data = JSON.parse(e.data);
      if (data) {
        let auth;
        switch (data.action) {
          case 'authcheck':
            if (authcheckHandled) {
              break;
            }
            authcheckHandled = true;
            clearAuthcheckTimeout();
            auth = store.getState().auth;
            if (data.status === 'ok') {
              let userData = store.getState().userData;
              let year = store.getState().year;
              /*
              if (auth.user) {
                let yearCheck = auth.user.app_years.find(
                  (item) => item >= year.data.settingYear
                );
                if (yearCheck == null) {
                  toast.warn(
                    year.data.settingYear +
                      '年度購入履歴がありません。この端末はログアウトしました。'
                  );
                  uploadUserData(user, userData, true);
                }
              }
              */

              if (year.data && year.data.noLoginFlag) {
                toast.warn(
                  '現在ログイン制御中です。この端末はログアウトしました。'
                );
                uploadUserDataInBackground(user, userData, true);
              } else {
                uploadUserDataInBackground(user, userData);
              }
            } else {
              //ログイン状態不可
              if (auth.user) {
                toast.warn(
                  '現在別の端末でログインしています。この端末はログアウトしました。'
                );
                let userData = store.getState().userData;
                uploadUserDataInBackground(auth.user, userData, true);
              }
            }
            break;
          case 'logout':
            authcheckHandled = true;
            clearAuthcheckTimeout();
            auth = store.getState().auth;
            if (auth.user) {
              toast.warn(
                '同じブラウザで複数のアプリを起動した （又は、 別の端末でログインした ）ため、こちらのアプリはログアウトしました。',
                { autoClose: false }
              );
              let userData = store.getState().userData;
              uploadUserDataInBackground(user, userData, true);
            }

            break;
          default:
            break;
        }
      }
    };
  };
  ws.onerror = (error) => {
    console.error('ws error', error);
    fallbackAuthcheck();
  };
  ws.onclose = () => {
    console.log('ws close');
    window.ws = undefined;
    fallbackAuthcheck();
  };
  return ws;
}
export async function uploadUserData(user, userData, logoutFlag = false) {
  store.dispatch(actions.change('forms.isWhileUpdate', true));
  let forms = store.getState().forms;

  const { updateData, uploadFlag } = createUploadData(userData, forms, user.id);

  if (uploadFlag) {
    console.log('data upload');
    updateData.setting = {
      global: forms.global,
      prediction: forms.prediction,
      resolve: {
        resolveQuestion: forms.search.resolveQuestion,
        resolveQuestionIndex: forms.search.resolveQuestionIndex,
        resolveUpdateDate: forms.search.resolveUpdateDate,
      },
    };
    appEventHandler.emitUploadAttempt();
    if (!window.navigator.onLine) {
      console.log('skip upload while offline');
      store.dispatch(actions.change('forms.isWhileUpdate', false));
      toast.warn('オフラインのため同期できません。');
      if (logoutFlag) {
        store.dispatch(actions.change('forms.showLogoutModal', true));
      }
      return Promise.reject(new Error('offline'));
    }
    store.dispatch(sendUpdateData());
    const { payload, err } = await superFetch({
      url: '/api/user_data',
      type: 'POST',
      data: updateData,
    });

    if (payload && !err) {
      console.log('success send update data');
      store.dispatch(successSendUpdateData(Object.assign({}, updateData)));
      if (logoutFlag) {
        store.dispatch(clickLogout());
      }
    } else {
      console.log('fail send update data');
      const errorMessage = `データの同期に失敗しました。通信環境をご確認の上、再度お試しください。(${String(
        err
      )})`;
      toast.error(errorMessage, { autoClose: 10000 });
      if (logoutFlag) {
        store.dispatch(actions.change('forms.showLogoutModal', true));
      }
      store.dispatch(failSendUpdateData(String(err)));
      store.dispatch(actions.change('forms.isWhileUpdate', false));
      // エラーを呼び出し元に伝える
      return Promise.reject(err);
    }
  } else {
    console.log('no data upload');
    if (logoutFlag) {
      store.dispatch(clickLogout());
    }
  }
  store.dispatch(actions.change('forms.isWhileUpdate', false));
  return Promise.resolve();
}

export function createUploadData(userData, forms, userId = null) {
  let uploadFlag = false;
  let updateData = {};

  if (userId) {
    updateData.id = userId;
  }

  updateData.now = moment().format();
  if (userData.lastUpdate) {
    updateData.lastUpdate = userData.lastUpdate;
  } else {
    updateData.lastUpdate = moment('20180101', 'YYYYMMDD').format();
  }
  console.log('login upload...');
  updateData.questionProgress = [];
  _.map(userData.questionProgress, (data) => {
    let updatedFlag = false;
    if (!data.updateDate) {
      if (_.size(data) > 1) {
        data.updateDate = updateData.now;
        updatedFlag = true;
      }
    } else {
      if (moment(data.updateDate).isAfter(updateData.lastUpdate)) {
        updatedFlag = true;
      }
    }
    if (updatedFlag) {
      updateData.questionProgress.push(data);
      uploadFlag = true;
    }
  });

  updateData.questionState = [];
  _.map(userData.questionState, (data) => {
    let updatedFlag = false;
    if (!data.updateDate) {
      if (_.size(data) > 1) {
        if (
          _.size(data) === 2 &&
          data.selection &&
          _.size(data.selection) === 0
        ) {
        } else {
          data.updateDate = updateData.now;
          updatedFlag = true;
        }
      }
    } else {
      if (moment(data.updateDate).isAfter(updateData.lastUpdate)) {
        updatedFlag = true;
      }
    }
    if (updatedFlag) {
      updateData.questionState.push(data);
      uploadFlag = true;
    }
  });

  updateData.questionSuggest = [];
  _.map(userData.questionSuggest, (data) => {
    let updatedFlag = false;
    if (!data.updateDate) {
      if (_.size(data) > 1) {
        data.updateDate = updateData.now;
        updatedFlag = true;
      }
    } else {
      if (moment(data.updateDate).isAfter(updateData.lastUpdate)) {
        updatedFlag = true;
      }
    }
    if (updatedFlag) {
      updateData.questionSuggest.push(data);
      uploadFlag = true;
    }
  });
  updateData.dayProgress = [];
  _.map(userData.dayProgress, (data) => {
    let updatedFlag = false;
    if (moment(data.update_date).isAfter(updateData.lastUpdate)) {
      updatedFlag = true;
    }
    if (updatedFlag) {
      updateData.dayProgress.push(data);
      uploadFlag = true;
    }
  });
  if (
    userData.resetQuestionStateDate &&
    moment(userData.resetQuestionStateDate).isAfter(updateData.lastUpdate)
  ) {
    updateData.resetQuestionStateDate = userData.resetQuestionStateDate;
    console.log('state update');
    uploadFlag = true;
  }
  if (
    userData.resetQuestionSuggestDate &&
    moment(userData.resetQuestionSuggestDate).isAfter(updateData.lastUpdate)
  ) {
    updateData.resetQuestionSuggestDate = userData.resetQuestionSuggestDate;
    console.log('suggest update');
    uploadFlag = true;
  }
  if (
    userData.resetQuestionProgressDate &&
    moment(userData.resetQuestionProgressDate).isAfter(updateData.lastUpdate)
  ) {
    updateData.resetQuestionProgressDate = userData.resetQuestionProgressDate;
    console.log('progress update');
    uploadFlag = true;
  }
  if (
    userData.resetDayProgressDate &&
    moment(userData.resetDayProgressDate).isAfter(updateData.lastUpdate)
  ) {
    updateData.resetDayProgressDate = userData.resetDayProgressDate;
    console.log('dayprogress update');
    uploadFlag = true;
  }
  updateData.printCount = userData.printCount;
  if (
    forms.global.updateDate &&
    moment(forms.global.updateDate).isAfter(updateData.lastUpdate)
  ) {
    console.log('setting update ');
    uploadFlag = true;
  }
  if (!forms.prediction.updateDate) {
    store.dispatch(
      actions.change('forms.prediction.updateDate', moment().format())
    );
    uploadFlag = true;
  } else {
    if (moment(forms.prediction.updateDate).isAfter(updateData.lastUpdate)) {
      console.log('prediction update ');
      uploadFlag = true;
    }
  }
  if (!forms.search.resolveUpdateDate) {
    store.dispatch(
      actions.change('forms.search.resolveUpdateDate', moment().format())
    );
    uploadFlag = true;
  } else {
    if (moment(forms.search.resolveUpdateDate).isAfter(updateData.lastUpdate)) {
      console.log('resolveSet update ');
      uploadFlag = true;
    }
  }

  if (uploadFlag) {
    updateData.setting = {
      global: forms.global,
      prediction: forms.prediction,
      resolve: {
        resolveQuestion: forms.search.resolveQuestion,
        resolveQuestionIndex: forms.search.resolveQuestionIndex,
        resolveUpdateDate: forms.search.resolveUpdateDate,
      },
    };
  }

  return { updateData, uploadFlag };
}

export function hasUnsyncedData(userData, forms) {
  const lastUpdate =
    userData.lastUpdate || moment('20180101', 'YYYYMMDD').format();

  if (
    _.some(userData.questionProgress, (data) => {
      if (!data.updateDate) {
        return _.size(data) > 1;
      }
      return moment(data.updateDate).isAfter(lastUpdate);
    })
  ) {
    return true;
  }

  if (
    _.some(userData.questionState, (data) => {
      let updatedFlag = false;
      if (!data.updateDate) {
        if (_.size(data) > 1) {
          if (
            _.size(data) === 2 &&
            data.selection &&
            _.size(data.selection) === 0
          ) {
            // no-op
          } else {
            updatedFlag = true;
          }
        }
      } else {
        if (moment(data.updateDate).isAfter(lastUpdate)) {
          updatedFlag = true;
        }
      }
      return updatedFlag;
    })
  ) {
    return true;
  }

  if (
    _.some(userData.questionSuggest, (data) => {
      if (!data.updateDate) {
        return _.size(data) > 1;
      }
      return moment(data.updateDate).isAfter(lastUpdate);
    })
  ) {
    return true;
  }

  if (
    _.some(userData.dayProgress, (data) =>
      moment(data.update_date).isAfter(lastUpdate)
    )
  ) {
    return true;
  }

  if (
    userData.resetQuestionStateDate &&
    moment(userData.resetQuestionStateDate).isAfter(lastUpdate)
  ) {
    return true;
  }
  if (
    userData.resetQuestionSuggestDate &&
    moment(userData.resetQuestionSuggestDate).isAfter(lastUpdate)
  ) {
    return true;
  }
  if (
    userData.resetQuestionProgressDate &&
    moment(userData.resetQuestionProgressDate).isAfter(lastUpdate)
  ) {
    return true;
  }
  if (
    userData.resetDayProgressDate &&
    moment(userData.resetDayProgressDate).isAfter(lastUpdate)
  ) {
    return true;
  }

  if (
    forms.global.updateDate &&
    moment(forms.global.updateDate).isAfter(lastUpdate)
  ) {
    return true;
  }

  if (
    forms.prediction.updateDate &&
    moment(forms.prediction.updateDate).isAfter(lastUpdate)
  ) {
    return true;
  }

  if (
    forms.search.resolveUpdateDate &&
    moment(forms.search.resolveUpdateDate).isAfter(lastUpdate)
  ) {
    return true;
  }

  return false;
}

export async function updateUserData(auth, global, forms) {
  console.log('update user data start');
  if (!window.navigator.onLine) {
    console.log('offline');
    if (auth.user) {
      const { userData } = store.getState();
      const { uploadFlag } = createUploadData(userData, forms, auth.user.id);
      if (uploadFlag) {
        appEventHandler.emitUploadAttempt();
      }
    }
    if (window.ws) {
      console.log('socket exists close...');
      window.ws.close();
    } else {
      console.log('socket no exists');
    }
    return;
  }
  if (!auth.user) {
    console.log('no login');
    return false;
  }
  if (forms.isWhileUpdate) {
    console.log('while update close');
    return false;
  }
  //他の端末でログインしていないかチェック
  if (!window.ws) {
    console.log('socket close... open.');
    openSocket(auth.user, global);
  } else {
    console.log('authcheck');
    if (window.ws.readyState !== 1) {
      console.log('ws closing or closed state. reopen.');
      window.ws.close();
      openSocket(auth.user, global);
    } else {
      try {
        window.ws.send(
          JSON.stringify({ action: 'authcheck', email: auth.user.email })
        );
      } catch (error) {
        console.error('ws send authcheck failed', error);
        window.ws = undefined;
        fallbackUploadAfterSocketFailure(auth.user);
      }
    }
  }
  return true;
}
export const getProgress = () => {
  let question = store.getState().question;
  let forms = store.getState().forms;
  let year = store.getState().year;
  let global = store.getState().global;
  let userData = store.getState().userData;
  let total = {
    division1s: [],
    count: 0,
    progress: {
      total: 0,
      success: 0,
      warning: 0,
      danger: 0,
    },
    rate: {
      total: 0,
      success: 0,
      warning: 0,
      danger: 0,
    },
  };
  let rankAll = {
    division1s: [],
    count: 0,
    progress: {
      total: 0,
      success: 0,
      warning: 0,
      danger: 0,
    },
    rate: {
      total: 0,
      success: 0,
      warning: 0,
      danger: 0,
    },
  };
  let rank10percent = {
    division1s: [],
    count: 0,
    progress: {
      total: 0,
      success: 0,
      warning: 0,
      danger: 0,
    },
    rate: {
      total: 0,
      success: 0,
      warning: 0,
      danger: 0,
    },
  };
  let rank20percent = {
    division1s: [],
    count: 0,
    progress: {
      total: 0,
      success: 0,
      warning: 0,
      danger: 0,
    },
    rate: {
      total: 0,
      success: 0,
      warning: 0,
      danger: 0,
    },
  };
  let seq = 0;
  _.each(question.division1, (division1) => {
    let tempDivision1 = {
      id: division1.id,
      name: division1.name,
    };
    let questions = _.filter(question.questions, {
      division1_id: division1.id,
    });
    let filterd = [];
    let count = 0;
    let progress = {
      total: 0,
      success: 0,
      warning: 0,
      danger: 0,
    };
    let rate = {
      total: 0,
      success: 0,
      warning: 0,
      danger: 0,
    };
    let sheet = _.filter(question.sheet, {
      division1_id: division1.id,
    });
    let tempSheet = {};
    sheet.forEach((item, index) => {
      tempSheet[item.id] = {
        id: index + 1,
        sheetId: item.id,
        seq: item.seq,
        name: item.name,
        count: 0,
        progress: {
          total: 0,
          success: 0,
          warning: 0,
          danger: 0,
        },
        rate: {
          total: 0,
          success: 0,
          warning: 0,
          danger: 0,
        },
      };
    });

    let start, end;

    let searchMode = global.searchMode[forms.global.searchMode];
    start = year.data.yearJa - searchMode.start;
    end = year.data.yearJa - searchMode.start - searchMode.span;

    filterd = _.filter(questions, (data) => {
      if (data.year <= start && data.year > end) {
        let ud = _.find(userData.questionProgress, { id: data.id });
        if (!tempSheet[data.sheet_id]) return false;
        tempSheet[data.sheet_id].count++;
        if (ud && ud.progress && ud.progress.length > 0) {
          progress.total++;
          tempSheet[data.sheet_id].progress.total++;
          switch (ud.progress) {
            case 'success':
              progress.success++;
              tempSheet[data.sheet_id].progress.success++;
              break;
            case 'warning':
              progress.warning++;
              tempSheet[data.sheet_id].progress.warning++;
              break;
            case 'danger':
              progress.danger++;
              tempSheet[data.sheet_id].progress.danger++;
              break;
            default:
              break;
          }
        }
        return true;
      }
    });
    count = _.size(filterd);
    if (count) {
      rate.total = _.round((progress.total * 100) / count, 1);
      rate.success = _.round((progress.success * 100) / count, 1);
      rate.warning = _.round((progress.warning * 100) / count, 1);
      rate.danger = _.round((progress.danger * 100) / count, 1);
    }
    total.count += count;
    total.progress.total += progress.total;
    total.progress.success += progress.success;
    total.progress.warning += progress.warning;
    total.progress.danger += progress.danger;
    tempDivision1.seq = ++seq;
    tempDivision1.count = count;
    tempDivision1.rate = rate;
    tempDivision1.progress = progress;
    tempDivision1.date = moment();
    tempDivision1.division1s = [];
    _.each(tempSheet, (data, sheet_id) => {
      if (data.count) {
        data.rate.total = _.round((data.progress.total * 100) / data.count, 1);
        data.rate.success = _.round(
          (data.progress.success * 100) / data.count,
          1
        );
        data.rate.warning = _.round(
          (data.progress.warning * 100) / data.count,
          1
        );
        data.rate.danger = _.round(
          (data.progress.danger * 100) / data.count,
          1
        );
        data.date = moment();
        tempDivision1.division1s.push(data);
      }
    });

    total.division1s.push(tempDivision1);
  });
  total.rate = {
    total: _.round((total.progress.total * 100) / total.count, 1),
    success: _.round((total.progress.success * 100) / total.count, 1),
    danger: _.round((total.progress.danger * 100) / total.count, 1),
    warning: _.round((total.progress.warning * 100) / total.count, 1),
  };
  total.name = '総合';
  if (userData.rankProgress) {
    let objs = [
      {
        source: userData.rankProgress.rankAll,
        sheetSource: userData.rankProgress.rankAllSheet,
        target: rankAll,
      },
      {
        source: userData.rankProgress.rank10percent,
        sheetSource: userData.rankProgress.rank10percentSheet,
        target: rank10percent,
      },
      {
        source: userData.rankProgress.rank20percent,
        sheetSource: userData.rankProgress.rank20percentSheet,
        target: rank20percent,
      },
    ];
    _.each(objs, (obj) => {
      obj.target.count = total.count;
      obj.target.name = '総合';
      let filterdList = [];
      let filterdSheetList = [];
      switch (forms.global.searchMode) {
        case '0': // 直近10年
          filterdList = _.filter(obj.source, {
            type: 0,
          });
          filterdSheetList = _.filter(obj.sheetSource, {
            type: 0,
          });
          break;
        case '1': // 次の10年
          filterdList = _.filter(obj.source, {
            type: 1,
          });
          filterdSheetList = _.filter(obj.sheetSource, {
            type: 1,
          });
          break;
        case '2': // 次の10年
          filterdList = _.filter(obj.source, {
            type: 2,
          });
          filterdSheetList = _.filter(obj.sheetSource, {
            type: 2,
          });
          break;
        default:
          //20年
          filterdList = Object.assign([], obj.source);
          filterdSheetList = Object.assign([], obj.sheetSource);
      }
      _.each(total.division1s, (division1) => {
        let tempList = [];
        let progress = {
          total: 0,
          success: 0,
          warning: 0,
          danger: 0,
        };
        let rate = {
          total: 0,
          success: 0,
          warning: 0,
          danger: 0,
        };
        tempList = _.filter(filterdList, { division1_id: division1.id });
        let tempList2 = [];
        tempList2 = _.filter(tempList, { progress: 'success' });

        _.each(tempList2, (item) => {
          progress.total += item.count;
          progress.success += item.count;
        });
        tempList2 = _.filter(tempList, { progress: 'warning' });
        _.each(tempList2, (item) => {
          progress.total += item.count;
          progress.warning += item.count;
        });
        tempList2 = _.filter(tempList, { progress: 'danger' });
        _.each(tempList2, (item) => {
          progress.total += item.count;
          progress.danger += item.count;
        });
        obj.target.progress.total += progress.total;
        obj.target.progress.success += progress.success;
        obj.target.progress.warning += progress.warning;
        obj.target.progress.danger += progress.danger;
        if (division1.count) {
          rate.total = _.round((progress.total * 100) / division1.count, 1);
          rate.success = _.round((progress.success * 100) / division1.count, 1);
          rate.warning = _.round((progress.warning * 100) / division1.count, 1);
          rate.danger = _.round((progress.danger * 100) / division1.count, 1);
        }
        let tempDivision1 = {
          id: division1.id,
          name: division1.name,
          division1s: [],
        };
        tempDivision1.count = division1.count;
        tempDivision1.progress = progress;
        tempDivision1.rate = rate;
        _.each(division1.division1s, (sheet) => {
          let tempList = [];
          let progress = {
            total: 0,
            success: 0,
            warning: 0,
            danger: 0,
          };
          let rate = {
            total: 0,
            success: 0,
            warning: 0,
            danger: 0,
          };
          tempList = _.filter(filterdSheetList, { sheet_id: sheet.sheetId });
          let tempList2 = [];
          tempList2 = _.filter(tempList, { progress: 'success' });

          _.each(tempList2, (item) => {
            progress.total += item.count;
            progress.success += item.count;
          });
          tempList2 = _.filter(tempList, { progress: 'warning' });
          _.each(tempList2, (item) => {
            progress.total += item.count;
            progress.warning += item.count;
          });
          tempList2 = _.filter(tempList, { progress: 'danger' });
          _.each(tempList2, (item) => {
            progress.total += item.count;
            progress.danger += item.count;
          });
          if (sheet.count) {
            rate.total = _.round((progress.total * 100) / sheet.count, 1);
            rate.success = _.round((progress.success * 100) / sheet.count, 1);
            rate.warning = _.round((progress.warning * 100) / sheet.count, 1);
            rate.danger = _.round((progress.danger * 100) / sheet.count, 1);
          }
          let tempSheet = {
            id: sheet.id,
            name: sheet.name,
          };
          tempSheet.count = sheet.count;
          tempSheet.progress = progress;
          tempSheet.rate = rate;
          tempDivision1.division1s.push(tempSheet);
        });
        obj.target.division1s.push(tempDivision1);
      });
      obj.target.rate = {
        total: _.round((obj.target.progress.total * 100) / total.count, 1),
        success: _.round((obj.target.progress.success * 100) / total.count, 1),
        danger: _.round((obj.target.progress.danger * 100) / total.count, 1),
        warning: _.round((obj.target.progress.warning * 100) / total.count, 1),
      };
    });
  }
  return {
    total: total,
    rankAll: rankAll,
    rank10percent: rank10percent,
    rank20percent: rank20percent,
  };
};
export const externalLink = ({ url, blank }) => {
  if (blank) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
};
export const updateDayProgress = (division1) => {
  let userData = store.getState().userData;
  let global = store.getState().global;
  if (!userData.dayProgress) {
    userData.dayProgress = {};
  }
  let dayProgress = Object.assign({}, userData.dayProgress);
  let date = moment()
    .add(-1 * global.delayStudyHours, 'hours')
    .format('YYYY-MM-DD');
  let dateObj;
  if (!dayProgress[date]) {
    dateObj = {
      event_date: date,
      count: 0,
      data: {},
      memo: '',
    };
  } else {
    dateObj = Object.assign({}, dayProgress[date]);
  }
  if (division1) {
    if (!dateObj.data) {
      dateObj.data = {};
    }
    if (dateObj.data[division1]) {
      dateObj.data[division1] += 1;
    } else {
      dateObj.data[division1] = 1;
    }
  }
  if (dateObj.count == null) {
    dateObj.count = 0;
  }
  dateObj.count++;
  dateObj.update_date = moment();
  dayProgress[date] = dateObj;

  let dateMoment = moment(date);
  let dow = dateMoment.day();
  if (dow === 0) {
    dow = 7;
  }
  dateMoment.add(-1 * dow, 'days').format('YYYY-MM-DD');
  let weekCount = 0;
  let data = {};
  for (let i = 0; i < 7; i++) {
    let weekday = dateMoment.add(1, 'days').format('YYYY-MM-DD');
    if (dayProgress[weekday]) {
      if (dayProgress[weekday].count) {
        weekCount += dayProgress[weekday].count;
        Object.keys(dayProgress[weekday].data).forEach((division1) => {
          if (data[division1] == null) {
            data[division1] = 0;
          }
          data[division1] += dayProgress[weekday].data[division1];
        });
      }
    }
  }
  let week = dateMoment.format('GGGG-WW');

  if (!dayProgress[week]) {
    dayProgress[week] = {
      event_week: week,
      count: 0,
      memo: '',
    };
  }
  dayProgress[week].data = data;
  dayProgress[week].count = weekCount;
  dayProgress[week].update_date = moment();

  store.dispatch(setDayProgress(dayProgress));
};
export const getSearchMode = () => {
  let year = store.getState().year.data.year;
  let global = store.getState().global;
  let searchMode = global.searchMode;
  let data = [];
  Object.keys(searchMode).forEach((key) => {
    let item = searchMode[key];
    let label = item.label;
    if (item.withYear) {
      let startYear = convertWareki(year - item.start - 1 + '-12-31');
      let endYear = convertWareki(year - item.start - item.span + '-12-31');
      label +=
        '(' +
        endYear.eraMark +
        endYear.year +
        '〜' +
        startYear.eraMark +
        startYear.year +
        'の' +
        item.span +
        '年間)';
    }
    data.push(label);
  });
  return data;
};

export const convertWareki = (val) => {
  if (val == null) return false;
  let tempVal = moment(val);
  if (!tempVal.isValid()) {
    return false;
  }
  if (tempVal.isAfter('2019-04-30')) {
    return {
      era: '令和',
      eraMark: 'R',
      year: ('0' + (tempVal.year() - 2018).toString()).substr(-2),
      month: tempVal.format('MM'),
      day: tempVal.format('DD'),
    };
  }
  if (tempVal.isBetween('1989-01-07', '2019-05-01')) {
    return {
      era: '平成',
      eraMark: 'H',
      year: ('0' + (tempVal.year() - 1988).toString()).substr(-2),
      month: tempVal.format('MM'),
      day: tempVal.format('DD'),
    };
  }
  if (tempVal.isBetween('1926-12-25', '1989-01-08')) {
    return {
      era: '昭和',
      eraMark: 'S',
      year: ('0' + (tempVal.year() - 1925).toString()).substr(-2),
      month: tempVal.format('MM'),
      day: tempVal.format('DD'),
    };
  }
  if (tempVal.isBetween('1912-07-30', '1926-12-26')) {
    return {
      era: '大正',
      eraMark: 'T',
      year: ('0' + (tempVal.year() - 1911).toString()).substr(-2),
      month: tempVal.format('MM'),
      day: tempVal.format('DD'),
    };
  }
  if (tempVal.isBetween('1868-09-07', '1912-07-31')) {
    return {
      era: '明治',
      eraMark: 'M',
      year: ('0' + (tempVal.year() - 1867).toString()).substr(-2),
      month: tempVal.format('MM'),
      day: tempVal.format('DD'),
    };
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/modules/common.js